type JsonObject = Record<string, unknown>;

function parseObject(json: string, what: string): JsonObject {
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch {
    throw new Error(`${what} is not valid JSON`);
  }
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error(`${what} is not a JSON object`);
  }
  return parsed as JsonObject;
}

// Puts the published flow into the operator's kiosk settings JSON.
// flowJson is the backoffice's prepared JSON ({ screenFlow, promoBannerFileName? }) and is used as is.
// Sets screenFlow, sets promoBannerFileName or removes it when empty; every other key is kept.
// promoBannerUrl is the old name of the field and is always removed.
// Unreadable settings throw rather than being overwritten.
export function mergeFlowIntoSettings(settingsJson: string | null | undefined, flowJson: string): string {
  const settings = settingsJson?.trim() ? parseObject(settingsJson, 'Current kiosk settings') : {};
  const flow = parseObject(flowJson, 'Flow JSON');
  if (!Array.isArray(flow.screenFlow)) {
    throw new Error('Flow JSON has no screenFlow');
  }

  const merged: JsonObject = { ...settings, screenFlow: flow.screenFlow };
  delete merged.promoBannerUrl;
  const banner = typeof flow.promoBannerFileName === 'string' ? flow.promoBannerFileName.trim() : '';
  if (banner) {
    merged.promoBannerFileName = banner;
  } else {
    delete merged.promoBannerFileName;
  }
  return JSON.stringify(merged);
}
